import {Typography} from '@mui/material';
import MaterialLink from '@mui/material/Link';
import PropTypes from 'prop-types';
import React from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import selectors from 'src/modules/clasificacionTercero/clasificacionTerceroSelectors';

function ClasificacionTerceroViewItem(props) {
  const hasPermissionToRead = useSelector(selectors.selectPermissionToRead);

  const valueAsArray = () => {
    const {value} = props;

    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    return [value];
  };

  const displayableRecord = (record) => {
    if (hasPermissionToRead) {
      return (
        <div key={record.id}>
          <MaterialLink component={Link} to={`/clasificacion-tercero/${record.id}`}>
            {record.descripcion}
          </MaterialLink>
        </div>
      );
    }

    return <div key={record.id}>{record.descripcion}</div>;
  };

  if (!valueAsArray().length) {
    return null;
  }

  return (
    <div style={{marginBottom: '16px'}}>
      <Typography variant="subtitle2">{props.label}</Typography>
      {valueAsArray().map((value) => displayableRecord(value))}
    </div>
  );
}

ClasificacionTerceroViewItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
};

export default ClasificacionTerceroViewItem;
